import WarrantyApiService from '@/services/WarrantyApiService/WarrantyApiService'
import { useUserStore } from '@/stores/user.store'
import { useQuery } from '@tanstack/vue-query'

import type { Ref } from 'vue'

export function fetchAddTagToShipping(
  tagSerialNumber: Ref<string | null>,
  carrierTagId: Ref<string | null>,
  shippingId: string,
  shippingReceipt: Ref<{ id: string } | null>
) {
  return useQuery<unknown, Error>({
    queryKey: ['add-tag-to-shipping'],
    queryFn: async () => {
      const userStore = useUserStore()

      const response = await WarrantyApiService.addTagToShipping({
        tagSerialNumberOrProductSku: tagSerialNumber.value!,
        carrierTagId: carrierTagId.value ?? undefined,
        shippingReceiptId: shippingReceipt.value!.id!,
        activityId: userStore.decodedToken?.activity.id!,
        shippingId: shippingId,
        productionSequenceOperationId: userStore.decodedToken?.productionSequenceOperation.id!
      })

      if (response.isWrong()) {
        const error = new Error(response.value.message)
        error.name = response.value.name
        throw error
      }

      return {}
    },
    retry: false,
    enabled: false
  })
}
